import Header from "../components/Header";

import Button from "../components/Button";

export default function Products() {
  return (
    <>
      <Header
        title="Products"
        subtitle="A closer look at the tools I'm building."
      />
      <section className="section" id="note-ninja">
        <div className="container">
          <article className="card">
            <header className="cardHeader">
              <img
                className="cardIcon"
                src="/images/note-ninja-icon.png"
                alt=""
                aria-hidden="true"
              />
              <div className="cardHeaderText">
                <h3 className="cardTitle">Note Ninja</h3>
                <p className="cardDescription">
                  An Android app for learning to read music fluently.
                </p>
              </div>
            </header>
            <div className="divider" />
            <p>
              Note Ninja helps you build automatic note recognition so reading
              sheet music becomes natural instead of effortful — for beginners
              and developing musicians alike.
            </p>
            <h3>Who it's for</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Beginners learning to read music notation
              </li>
              <li className="bulletListItem">
                Musicians who want to improve reading speed and accuracy
              </li>
              <li className="bulletListItem">
                Instrumentalists practicing with treble or bass clef
              </li>
            </ul>
            <h3>What it solves</h3>
            <ul className="bulletList">
              <li className="bulletListItem">Slow, conscious note decoding</li>
              <li className="bulletListItem">
                Hesitation when reading sheet music
              </li>
              <li className="bulletListItem">
                Unstructured or inefficient reading practice
              </li>
            </ul>
            <h3>What makes it powerful</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Works without any external hardware
              </li>
              <li className="bulletListItem">
                <strong>Optional Bluetooth MIDI support</strong> for digital
                instruments
              </li>
              <li className="bulletListItem">
                Real-time feedback when connected to a MIDI device
              </li>
              <li className="bulletListItem">
                Practice designed around reading skills, not songs
              </li>
            </ul>
            <h3>Highlights</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Treble and bass clef note reading
              </li>
              <li className="bulletListItem">
                Short, focused exercises for daily practice
              </li>
              <li className="bulletListItem">
                Clean interface without distractions
              </li>
              <li className="bulletListItem">
                Chord support currently in development, with scales planned next
              </li>
            </ul>
            <h3>Availability</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Available now on <strong>Android</strong>
              </li>
              <li className="bulletListItem">iOS coming soon</li>
            </ul>
            <Button href="https://play.google.com/store/apps/details?id=com.noteninja">
              Get it on Google Play
            </Button>
          </article>
        </div>
      </section>
      <section className="section" id="record-health">
        <div className="container">
          <article className="card">
            <header className="cardHeader">
              <img
                className="cardIcon"
                src="/images/record-health-icon.png"
                alt=""
                aria-hidden="true"
              />
              <div className="cardHeaderText">
                <h3 className="cardTitle">Record Health</h3>
                <p className="cardDescription">
                  A Salesforce-native tool for making data quality visible and
                  actionable.
                </p>
              </div>
            </header>
            <p>
              Record Health shows users the quality of a record directly on the
              Lightning page — with clear feedback on what's missing, what's
              wrong, and how to fix it.
            </p>
            <h3>Who it's for</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Salesforce users working with records every day
              </li>
              <li className="bulletListItem">
                Teams responsible for keeping data accurate and complete
              </li>
              <li className="bulletListItem">
                Organizations that need consistent data without relying on admin
                intervention
              </li>
            </ul>
            <h3>What it solves</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Data quality rules hidden in validation logic
              </li>
              <li className="bulletListItem">
                Unclear responsibility for fixing bad data
              </li>
              <li className="bulletListItem">
                Complex requirements that are hard to explain to end users
              </li>
            </ul>
            <h3>How it works</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                Rules are defined per object through a dedicated UI
              </li>
              <li className="bulletListItem">
                Rules can be simple or use{" "}
                <strong>logical conditions across multiple fields</strong>
              </li>
              <li className="bulletListItem">
                Each rule includes:
                <br />
                A user-facing message
                <br />
                Optional guidance on how to fix the issue
                <br />A configurable weight contributing to the overall score
              </li>
              <li className="bulletListItem">
                Variants allow different rule sets for different record types or
                use cases
              </li>
            </ul>
            <h3>On the record page</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                A Lightning Web Component displays the current data quality
              </li>
              <li className="bulletListItem">
                Visual score from 0 to 100, shown as a donut or bar
              </li>
              <li className="bulletListItem">
                Color thresholds are configurable to match your definition of
                "healthy data"
              </li>
              <li className="bulletListItem">
                Users immediately see what needs attention — without leaving the
                record
              </li>
            </ul>
            <h3>Why it's different</h3>
            <ul className="bulletList">
              <li className="bulletListItem">
                No admin or developer input required after setup
              </li>
              <li className="bulletListItem">
                Complex data logic without complex configuration
              </li>
              <li className="bulletListItem">
                Designed for people who work in Salesforce, not just manage it
              </li>
            </ul>
            <h3>Availability</h3>
            <ul className="bulletList">
              <li className="bulletListItem">Delivered as a managed package</li>
              <li className="bulletListItem">
                Ready to be installed and configured
              </li>
            </ul>
            <Button href="/contact">Contact me</Button>
          </article>
        </div>
      </section>
    </>
  );
}
